const NotFound = () => {
  return <div className="text-center">not found</div>;
};

export default NotFound;
